
import Grid from "@mui/material/Grid";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import OpportunityCard from "./OpportunityCard";
import {useLocation} from "react-router-dom";
import SearchBar from "./SearchBar";
import {getOpportunities} from "../../utilities/HrAPI";
import {getCategoryByValue} from "./JobCard";

export default function JobOpportunities() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const clientId = queryParams.get('clientId')
    const [searchTerm, setSearchTerm] = useState("");
    const [dummyState, setDummyState] = useState(0);
    const [opportunities, setOpportunities] = useState([]);
    const [filteredOpportunities, setFilteredOpportunities] = useState([]);

    useEffect(() => {
        getOpportunities(clientId)
            .then(opportunities => {
                setOpportunities(opportunities)
                console.log(opportunities)
            })
            .catch((e) => {
                console.error("Error fetching jobs:", e);
            });
    }, [clientId]);

    useEffect(() => {
        if (searchTerm.trim() === "") {
            setFilteredOpportunities(opportunities); // Reset to the original jobs list
        } else {
            const filtered = opportunities.filter(opp =>
                getCategoryByValue(opp.jobcategory).toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredOpportunities(filtered);
        }
        setDummyState(prev => prev + 1);
    }, [searchTerm, opportunities]);

    const handleSearch = (search) => {
        setSearchTerm(search); // Immediately update the search term
    };


    return (
        <Box data-testid={"listings-page"} style={{height: 'max-content', backgroundColor: '#f3f3f3', elevation: 1}}>
            <Grid container spacing={2} padding={2} direction={"row"} justifyContent={"stretch"}>

                <Grid item xs={12} hidden={true}>
                    <SearchBar onSearch={(search) => {handleSearch(search)}} regions={null} types={null} categories={null}/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container direction={"row"} spacing={2} padding={2} key={dummyState}>
                        {filteredOpportunities.map((opportunity, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                <OpportunityCard opportunity={opportunity} clientId={clientId}/>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )

}